import React from 'react';
import JobPortalRoleComponent from "../components/JobPortalRoleComponent";
import useStore from "../zustand/useStore";
import JobPortalDesktopDashboard from "../components/JobPortalDesktopDashboard";

export default function JobPortalDesktopPage({renderHeaderPage,isMobile}) {
    const {userAuthDetail} = useStore();
    const {userInfo} = userAuthDetail;
    if(userInfo?.job_portal_role) {
        return (
            <JobPortalDesktopDashboard isMobile={isMobile} renderHeaderPage={renderHeaderPage}/>
        );
    }else{
        return (
            <JobPortalRoleComponent renderHeaderPage={renderHeaderPage}/>
        )
    }
}
